import React from "react";
import PropTypes from "prop-types";

const SidebarTitle = ({ title }) => {
    return (
        <React.Fragment>
            <h1 className="widget-title">{title}</h1>
        </React.Fragment>
    );
};

SidebarTitle.propTypes = {
    title: PropTypes.string,
};

export default SidebarTitle;
